export const PLATFORM_CONTANTS = 'platform/constants/list';
export const PLATFORM_CONTANTS_LEASE_TYPE = 'platform/constants/lease_type_list';
export const PLATFORM_CONTANTS_LEASE_STATUS = 'platform/constants/lease_status_list'; 
export const AIRCRAFT_TYPES = 'platform/aircraft_types';
export const PORTFOLIO_LIST = 'platform/portfolios';
export const ENGINE_TYPES = 'platform/engine_types';
export const LESSOR_LIST = 'platform/lessor';
export const REGION_LIST = 'platform/regions';
export const LESSEE_LIST = 'platform/lessee';
export const OPERATOR_LIST = 'platform/operator';
export const MANUFACTURER_LIST = 'platform/manufacturer';
export const APU_TYPES = 'platform/apu_types';
export const AIRCRAFT_MNT_GRP = 'platform/aircraft/mnt/grp';
export const ASSETS_SWITCHER = 'platform/all/assets';
export const SHOW_TOAST = 'SHOW_TOAST';
export const HIDE_TOAST = 'HIDE_TOAST';
export const CLEAR_TOAST = 'CLEAR_TOAST';
export const PAGE_LOADER = 'PAGE_LOADER';
